import { useEffect } from 'react';

import { useAnalytics } from '@/hooks/use-analytics';
import { useCardThreadId } from '@/hooks/use-card-thread-id';
import { confirmationShownProperties } from '@/lib/analytics/gate-events';
import { CHAT_ANALYTICS_EVENTS } from '@/lib/constants/post-message-types';

// Per tab, so a thread switch or a remount does not report the same confirmation again; a reload
// may, which the DAL absorbs by call id.
const reportedThisTab = new Set<string>();

export function useConfirmationShown({
  toolCallId,
  toolName,
  shown,
}: {
  toolCallId: string;
  toolName: string;
  shown: boolean;
}): void {
  const { trackThreadEvent } = useAnalytics();
  const threadId = useCardThreadId();
  useEffect(
    function reportConfirmationShown() {
      if (!shown || reportedThisTab.has(toolCallId)) return;
      reportedThisTab.add(toolCallId);
      trackThreadEvent({
        event: CHAT_ANALYTICS_EVENTS.TOOL_APPROVAL_CONFIRMATION_SHOWN,
        properties: confirmationShownProperties({ toolCallId, toolName, channel: 'web' }),
        threadId,
      });
    },
    [shown, toolCallId, toolName, threadId, trackThreadEvent],
  );
}
